export default __webpack_public_path__ + "static/Case-Study-AI-Lead-Distribution-16d234d4d7bc746c18ce58f260f5f0e0.pdf";